import { ProjectResourceType } from 'src/constants/project';
import {
  LinkCategory,
  LinkLabelCategory,
  NodeCategory,
} from 'src/containers/ProjectDiagram/constants/categories';
import {
  BaseData,
  DeletedFileUpload,
  DeletedMapping,
  DeletedMappingLabel,
  DeletedModelConceptClass,
  DeletedModelConceptHierarchy,
  DeletedModelConceptHierarchyLabel,
  DeletedModelConceptRelationship,
  DeletedModelConceptRelationshipLabel,
  DeletedRelationshipMapping,
  DeletedResource,
  DeletedVirtualGraph,
  FileUpload,
  Mapping,
  MappingLabel,
  ModelConceptClass,
  ModelConceptHierarchy,
  ModelConceptHierarchyLabel,
  ModelConceptRelationship,
  ModelConceptRelationshipLabel,
  RelationshipMapping,
  Resource,
  VirtualGraph,
} from 'src/containers/ProjectDiagram/types/data';

// resources

export const isResource = (data: BaseData): data is Resource => {
  return data.category === NodeCategory.RESOURCE;
};

export const isFileUpload = (data: BaseData): data is FileUpload => {
  return isResource(data) && data.type === ProjectResourceType.FILE_UPLOAD;
};

export const isVirtualGraph = (data: BaseData): data is VirtualGraph => {
  return isResource(data) && data.type === ProjectResourceType.VIRTUAL_GRAPH;
};

// deleted resources

export const isDeletedResource = (data: BaseData): data is DeletedResource => {
  return data.category === NodeCategory.DELETED_RESOURCE;
};

export const isDeletedFileUpload = (
  data: BaseData
): data is DeletedFileUpload => {
  return (
    isDeletedResource(data) && data.type === ProjectResourceType.FILE_UPLOAD
  );
};

export const isDeletedVirtualGraph = (
  data: BaseData
): data is DeletedVirtualGraph => {
  return (
    isDeletedResource(data) && data.type === ProjectResourceType.VIRTUAL_GRAPH
  );
};

// mappings

export const isMappingLabel = (data: BaseData): data is MappingLabel => {
  return data.category === LinkLabelCategory.MAPPING_LABEL;
};

export const isMapping = (data: BaseData): data is Mapping => {
  return data.category === LinkCategory.MAPPING;
};

export const isRelationshipMapping = (
  data: BaseData
): data is RelationshipMapping => {
  return data.category === LinkCategory.RELATIONSHIP_MAPPING;
};

// deleted mappings

export const isDeletedMappingLabel = (
  data: BaseData
): data is DeletedMappingLabel => {
  return data.category === LinkLabelCategory.DELETED_MAPPING_LABEL;
};

export const isDeletedMapping = (data: BaseData): data is DeletedMapping => {
  return data.category === LinkCategory.DELETED_MAPPING;
};

export const isDeletedRelationshipMapping = (
  data: BaseData
): data is DeletedRelationshipMapping => {
  return data.category === LinkCategory.DELETED_RELATIONSHIP_MAPPING;
};

// concepts

export const isModelConceptClass = (
  data: BaseData
): data is ModelConceptClass => {
  return data.category === NodeCategory.MODEL_CONCEPT_CLASS;
};

export const isModelConceptRelationshipLabel = (
  data: BaseData
): data is ModelConceptRelationshipLabel => {
  return data.category === LinkLabelCategory.MODEL_CONCEPT_RELATIONSHIP_LABEL;
};

export const isModelConceptRelationship = (
  data: BaseData
): data is ModelConceptRelationship => {
  return data.category === LinkCategory.MODEL_CONCEPT_RELATIONSHIP;
};

export const isModelConceptHierarchy = (
  data: BaseData
): data is ModelConceptHierarchy => {
  return data.category === LinkCategory.MODEL_CONCEPT_HIERARCHY;
};

export const isModelConceptHierarchyLabel = (
  data: BaseData
): data is ModelConceptHierarchyLabel => {
  return data.category === LinkLabelCategory.MODEL_CONCEPT_HIERARCHY_LABEL;
};

// deleted concepts

export const isDeletedModelConceptClass = (
  data: BaseData
): data is DeletedModelConceptClass => {
  return data.category === NodeCategory.DELETED_MODEL_CONCEPT_CLASS;
};

export const isDeletedModelConceptRelationshipLabel = (
  data: BaseData
): data is DeletedModelConceptRelationshipLabel => {
  return (
    data.category === LinkLabelCategory.DELETED_MODEL_CONCEPT_RELATIONSHIP_LABEL
  );
};

export const isDeletedModelConceptRelationship = (
  data: BaseData
): data is DeletedModelConceptRelationship => {
  return data.category === LinkCategory.DELETED_MODEL_CONCEPT_RELATIONSHIP;
};

export const isDeletedModelConceptHierarchy = (
  data: BaseData
): data is DeletedModelConceptHierarchy => {
  return data.category === LinkCategory.DELETED_MODEL_CONCEPT_HIERARCHY;
};

export const isDeletedModelConceptHierarchyLabel = (
  data: BaseData
): data is DeletedModelConceptHierarchyLabel => {
  return (
    data.category === LinkLabelCategory.DELETED_MODEL_CONCEPT_HIERARCHY_LABEL
  );
};
